import { useNavigate } from 'react-router-dom'

import { FoodCostHeader } from '@/components/food-cost/FoodCostHeader'
import { FORM_HASH } from '@/components/food-cost/constants'
import { ROUTES } from '@/navigation/constants'
import { localizePath } from '@/navigation/locale'
import { useLandingLocale } from '@/navigation/useLandingLocale'
import type { LandingPage } from '@tipi/shared'

type SubpageFoodCostHeaderProps = {
    landingPage?: LandingPage
    ctaLabel?: string
    onCtaClick?: () => void
}

/** Same floating header as the food-cost landing, always visible on marketing subpages. */
export function SubpageFoodCostHeader({ landingPage, ctaLabel, onCtaClick }: SubpageFoodCostHeaderProps = {}) {
    const navigate = useNavigate()
    const locale = useLandingLocale()

    return (
        <FoodCostHeader
            progress={1}
            landingPage={landingPage}
            ctaLabel={ctaLabel}
            onCtaClick={
                onCtaClick ??
                (() => navigate({ pathname: localizePath(ROUTES.home, locale), hash: FORM_HASH.slice(1) }))
            }
        />
    )
}
